import { AbstractControl, ValidatorFn } from '@angular/forms';

export function forbiddenNamesValidator(words: string[]): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = words.includes(control.value.trim().toLowerCase());
    return forbidden ? {forbiddenNames: {value: control.value}} : null;
  };
}
